<div class="dash-component">
  <!-- Primeira Linha: 2 Cards Empilhados + 1 Gráfico Maior -->
  <div class="row mb-4">
    <!-- Cards da primeira linha - empilhados verticalmente -->
    <div class="col-lg-3 col-md-4">
      <div class="cards-stack">
        <div class="dash-card mb-3" *ngFor="let card of firstRowCards" [ngClass]="getCardColorClass(card.color)">
          <div class="card-body d-flex align-items-center">
            <div class="card-icon me-3">
              <i [class]="card.icon"></i>
            </div>
            <div class="card-content flex-grow-1">
              <div class="card-value">{{ card.value }}</div>
              <div class="card-title">{{ card.title }}</div>
              <div class="card-subtitle" *ngIf="card.subtitle">{{ card.subtitle }}</div>
              <div class="card-trend" *ngIf="card.trend" [ngClass]="getTrendColorClass(card.trend.isPositive)">
                <i class="fas" [ngClass]="getTrendIcon(card.trend.isPositive)"></i>
                {{ card.trend.value }}%
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Gráfico da primeira linha - maior -->
    <div class="col-lg-9 col-md-8">
      <div class="chart-container large-chart" *ngIf="firstRowChart">
        <div class="chart-header" *ngIf="firstRowChart.title">
          <h6 class="chart-title">{{ firstRowChart.title }}</h6>
        </div>
        <div class="chart-wrapper">
          <canvas [id]="getFirstChartId()"></canvas>
        </div>
      </div>
    </div>
  </div>

  <!-- Segunda Linha: 1 Gráfico Maior + 2 Cards Empilhados -->
  <div class="row">
    <!-- Gráfico da segunda linha - maior -->
    <div class="col-lg-9 col-md-8">
      <div class="chart-container large-chart" *ngIf="secondRowChart">
        <div class="chart-header" *ngIf="secondRowChart.title">
          <h6 class="chart-title">{{ secondRowChart.title }}</h6>
        </div>
        <div class="chart-wrapper">
          <canvas [id]="getSecondChartId()"></canvas>
        </div>
      </div>
    </div>

    <!-- Cards da segunda linha - empilhados verticalmente -->
    <div class="col-lg-3 col-md-4">
      <div class="cards-stack">
        <div class="dash-card mb-3" *ngFor="let card of secondRowCards" [ngClass]="getCardColorClass(card.color)">
          <div class="card-body d-flex align-items-center">
            <div class="card-icon me-3">
              <i [class]="card.icon"></i>
            </div>
            <div class="card-content flex-grow-1">
              <div class="card-value">{{ card.value }}</div>
              <div class="card-title">{{ card.title }}</div>
              <div class="card-subtitle" *ngIf="card.subtitle">{{ card.subtitle }}</div>
              <div class="card-trend" *ngIf="card.trend" [ngClass]="getTrendColorClass(card.trend.isPositive)">
                <i class="fas" [ngClass]="getTrendIcon(card.trend.isPositive)"></i>
                {{ card.trend.value }}%
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
